import { render, staticRenderFns } from "./MeshView.vue?vue&type=template&id=a956f816&scoped=true&"
import script from "./MeshView.vue?vue&type=script&lang=js&"
export * from "./MeshView.vue?vue&type=script&lang=js&"
import style0 from "./MeshView.vue?vue&type=style&index=0&id=a956f816&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a956f816",
  null
  
)

export default component.exports